// export const API_URL = 'http://localhost:5001/api/' // local api url
// export const API_URL = 'https://psi-gcloud-stage-309113.el.r.appspot.com/api/' // stage api url
export const API_URL = 'https://portfoliosmith.in/api/' // prod api url
export const API_PSI_URL = 'https://api.portfoliosmith.in/' // prod psi url
// export const API_PSI_URL = 'https://stageapi.portfoliosmith.in/' // stage psi url
export const API_PRINT_URL = 'https://api.portfoliosmith.in/'
export const API_MSI_URL = 'https://marketsmithindia.com/gateway/simple-api/ms-india/instr/'
export const API_MSI_PORTFOLIO_URL = 'https://marketsmithindia.com/gateway/simple-api/ms-india/userPortfolio/'
export const MSI_API_AUTH = 'ms-auth=3990+MarketSmithINDUID-Web0000000000+MarketSmithINDUID-Web0000000000+3+190910230055+2134291654'
export const ANAND_RATHI_USER_HOLDINGS_API = "https://www.rathi.com/WON_researchAPI/Api/WonResearch"
export const API_CKYC_URL = "https://quantsmith.in/ckyc/api/"
export const API_MSI_PORTFOLIO_USERSUBSCRIPTION_URL = "https://api.marketsmithindia.com/msi_services/userSubscription/"



// WEBPACK FOOTER //
// ./src/api/config.js